//#region src/assets/failed-request.png
var failed_request_default = "" + new URL("failed-request-B5B_Pu5F.png", import.meta.url).href;
//#endregion
export { failed_request_default as default };

//# sourceMappingURL=failed-request.js.map